import React from 'react';
import { MenuItem, TextField, Tooltip } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import styles from './PeriodPicker.module.css';

export const ALL_RESOURCES = '';

const fieldSx = {
  width: 260,
  maxWidth: '100%',
  '& .MuiOutlinedInput-root': { height: '40px', borderRadius: 'var(--border-radius-sm)' },
};

const OWN_SCOPE_REASON = 'Com o alcance "Só os meus pacientes", as estatísticas mostram só a sua agenda.';
const OWN_AGENDA_REASON = 'No papel Equipe, as estatísticas mostram só a agenda ligada ao seu usuário.';
const OWN_AGENDA_NOTE = 'Mostra só a sua agenda, sem valores.';

/**
 * Filtro por profissional das estatísticas (statistics/get.php &resource=).
 * Só aparece com mais de uma agenda. Quem está no alcance "Só os meus
 * pacientes" vê o filtro travado na própria agenda, com o motivo.
 * A Equipe (`ownAgenda`) vê sempre o filtro travado, mesmo com uma agenda só,
 * com o aviso de que não há valores.
 *
 * `resources`: CompanyConfig.Resources ({ Id, Label, Active });
 * `value`: id escolhido ou ALL_RESOURCES; `lockedTo`: id da própria agenda (alcance próprio).
 */
const ResourceFilter = ({ resources, value, onChange, lockedTo = null, ownAgenda = false }) => {
  const isActive = (item) => item.Active == null || item.Active === true || Number(item.Active) === 1;
  const keep = (item) => isActive(item) || String(item.Id) === String(value) || String(item.Id) === String(lockedTo);
  const list = (resources || []).filter(keep);
  if (list.length < 2 && !ownAgenda) return null;

  const locked = lockedTo !== null;
  const lockedMissing = locked && !list.some((item) => String(item.Id) === String(lockedTo));
  const field = (
    <TextField
      select
      size="small"
      label="Profissional"
      value={locked ? String(lockedTo) : String(value)}
      onChange={(event) => onChange(event.target.value)}
      disabled={locked}
      sx={fieldSx}
      SelectProps={{ IconComponent: locked ? LockOutlinedIcon : undefined, MenuProps: { PaperProps: { sx: { maxHeight: 360 } } } }}
    >
      <MenuItem value={ALL_RESOURCES}>Todos os profissionais</MenuItem>
      {lockedMissing && <MenuItem value={String(lockedTo)}>Sem agenda vinculada</MenuItem>}
      {list.map((item) => (
        <MenuItem key={item.Id} value={String(item.Id)}>{item.Label}</MenuItem>
      ))}
    </TextField>
  );

  const filtered = locked || value !== ALL_RESOURCES;
  return (
    <div className={styles.resource}>
      {locked ? <Tooltip title={ownAgenda ? OWN_AGENDA_REASON : OWN_SCOPE_REASON}><span>{field}</span></Tooltip> : field}
      {filtered && (
        <span className={styles.resourceNote}>
          {ownAgenda
            ? OWN_AGENDA_NOTE
            : 'Agenda, receita dos atendimentos e atendidos são do profissional; recebido, despesas, cadastros, leads e satisfação são da conta toda.'}
        </span>
      )}
    </div>
  );
};

export default ResourceFilter;
